import React from "react"
import SEO from "../components/seo"
import styled from "@emotion/styled"
import Layout from "../components/layout"
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import Map from "../components/map"
import Ball from "../images/ball.png"
import ScrollButton from "../components/scrollButton"
import CheckoutButton from "../components/checkout"

/* Hero Styles */
const HeroContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  margin: 0;
  margin-top: 7rem;
  margin-bottom: 40rem;
  position: relative;

  @media (max-width: 425px) {
    margin-right: 1rem;
    margin-bottom: 40rem;
  }
`

const HeroText = styled.h1`
  font-size: 11rem;
  line-height: 11rem;
  margin-left: 4rem;
  z-index: 2;
  width: 70%;

  @media (max-width: 1600px) {
    font-size: 9rem;
    line-height: 9rem;
  }

  @media (max-width: 1400px) {
    font-size: 8rem;
    line-height: 8rem;
  }

  @media (max-width: 768px) {
    width: 70%;
    font-size: 6rem;
    line-height: 6rem;
    margin-left: 2rem;
  }

  @media (max-width: 425px) {
    width: 100%;
    font-size: 3.8rem;
    line-height: 4rem;
  }
  
  @media (max-width: 360px) {
      font-size: 3.5rem;
      line-height: 3.5rem;
  }
`

const HeroImageContainer = styled.div`
  position: absolute;
  left: 49%;
  top: 30%;
  width: 900px;
  object-fit: cover;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  @media (max-width: 1600px) {
    width: 850px;
  }

  @media (max-width: 1400px) {
    width: 800px;
  }

  @media (max-width: 1250px) {
    width: 750px;
    top: 25%;
  }

  @media (max-width: 768px) {
    left: 35%;
  }

  @media (max-width: 425px) {
    width: 500px;
    left: 20%;
    top: 68%;
  }
`

/* Intro Text Styles */
const IntroTextContainer = styled.div`
 width: 90%;
 margin-bottom: 10rem;
 padding-left: 10rem;
 position: relative;

  @media (max-width: 1400px) {
    padding-left: 8rem;
  }

  @media (max-width: 768px) {
    margin-bottom: 8rem;
    padding-left: 5rem;
  }

  @media (max-width: 425px) {
    width: 95%;
    padding-left: 4rem;
  }
`

const IntroText = styled.h2`
  text-align: right;
  font-size: 3rem;

  @media (max-width: 1250px) {
    margin: 0;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    line-height: 3rem;
  }

  @media (max-width: 425px) {
    text-align: left;
    font-size: 1.75rem;
    line-height: 2.25rem;
  }
`

/* Divider Img Styles */

const DividerImgContainer = styled.div`
  width: 90%;
  height: auto;
  object-fit: cover;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
  margin-bottom: 18rem;

  @media (max-width: 425px) {
    margin-bottom: 16rem;
  }

  @media (max-width: 360px) {
    margin-bottom: 14rem;
  }
`

/* Tagline Styles */

const BookTaglineContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  position: relative;
`

const Tagline = styled.h2`
  position: absolute;
  top: -30px;
  left: 210px;
  width: 50%;
  z-index: 2;
  font-size: 2.75rem;
  margin: 0;
  text-align: center;
  padding: 5rem;

  @media (max-width: 1600px) {
    width: 60%;
    top: -60px;
    left: 0;
  }

  @media (max-width: 1400px) {
    width: 70%;
    top: -60px;
    left: 0;
  }

  @media (max-width: 1250px) {
    width: 80%;
    font-size: 2.25rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    top: -300px;
    left: 0;
    padding: 7rem;
  }

  @media (max-width: 425px) {
    padding: 1.2rem;
    font-size: 1.75rem;
    top: -130px;
  }
  
  @media (max-width: 360px) {
    font-size: 1.5rem;
    padding: 2.5rem;
    top: -118px;
  }
`

const TaglineImgContainer = styled.div`
  width: 600px;
  object-fit: cover;
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0);

  @media (max-width: 425px) {
    width: 350px;
  }

  @media (max-width: 360px) {
    width: 300px;
  }
`

const TaglineDecoration = styled.div`
  width: 200px;
  object-fit: cover;
  position: absolute;
  bottom: -20px;
  right: 570px;

  @media (max-width: 1600px) {
    right: 400px;
  }

  @media (max-width: 1400px) {
    right: 300px;
  }

  @media (max-width: 1250px) {
    right: 200px;
  }

  @media (max-width: 768px) {
    right: 275px;
    bottom: -50px;
  }

  @media (max-width: 425px) {
    width: 100px;
    right: 140px;
  }
  
  @media (max-width: 360px) {
    right: 135px;
  }

  @media (max-width: 320px) {
    right: 110px;
  }
`

/* Map Styles */

const MapContainer = styled.div`
  height: 28rem;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  margin: 10rem 15rem 18rem 15rem;

  @media (max-width: 1400px) {
    width: 50rem;
    margin: 0 auto;
    margin-top: 10rem;
    margin-bottom: 20rem;
  }

  @media (max-width: 768px) {
    width: 90%;
  }

  @media (max-width: 425px) {
    height: 23rem;
    margin-bottom: 15rem;
  }
`
const MapTextContainer = styled.div`
 font-family: "Windsor";
 font-size: 3rem;
 text-align: center;
 display: -webkit-box;
 display: -ms-flexbox;
 display: flex;
 -webkit-box-align: center;
  -ms-flex-align: center;
 align-items: center;
 -webkit-box-pack: center;
  -ms-flex-pack: center;
 justify-content: center;
 z-index: 1;
 margin-bottom: 2rem;

 @media (max-width: 768px) {
   font-size: 2.75rem;
 }

 @media (max-width: 425px) {
   font-size: 1.5rem;
 }

 @media (max-width: 320px) {
  font-size: 1.3rem;
}
`

/*Call To Action Styles */

const CallToActionContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 5rem 10rem 5rem;

  @media (max-width: 1400px) {
    margin-left: 8rem;
    margin-right: 8rem;
  }

  @media (max-width: 1250px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  @media (max-width: 768px) {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  @media (max-width: 425px) {
    flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
  }
`

const ActionTextWrapper = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  width: 35%;

  @media (max-width: 1400px) {
    width: 45%;
  }

  @media (max-width: 1250px) {
    width: 50%;
  }

  @media (max-width: 768px) {
   width: 60%;
  }

  @media (max-width: 425px) {
    width: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 2rem;
  }
`

const ActionText = styled.h2`
  font-size: 4rem;

  @media (max-width: 1250px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
   font-size: 2.6rem;
   line-height: 3rem;
  }

  @media (max-width: 425px) {
    text-align: center;
    font-size: 2.3rem;
    line-height: 2.5rem;
  }

  @media (max-width: 360px) {
    font-size: 2rem;
    line-height: 2.2rem;
  }

  @media (max-width: 320px) {
    font-size: 1.85rem;
  }
`

const BookImgContainer = styled.div`
  width: 510px;

  @media (max-width: 425px) {
    width: 350px;
  }

  @media (max-width: 360px) {
    width: 300px;
  }
`

/* Ball Image Styles*/
const BallTitleImg = styled.img`
  width: 180px;
  height: 180px;
  margin: 0;
  margin-bottom: -2rem;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin-bottom: -1rem;
  }

  @media (max-width: 425px) {
    width: 60px;
    height: 60px;
    margin-bottom: -0.75rem;
  }
`

const MapBallImg = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: 1rem;

  @media (max-width: 425px) {
    width: 40px;
    height: 40px;
    margin-bottom: 0.25rem;
  }

  @media (max-width: 320px) {
    width: 30px;
    height: 30px;
    margin-bottom: 0.1rem;
  }
`

const BallActionImg = styled.img`
  margin-bottom: -1rem;
  width: 80px;
  height: 80px;

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    margin-bottom: -0.75rem;
  }

  @media (max-width: 425px) {
    width: 50px;
    height: 50px;
  }

  @media (max-width: 320px) {
    width: 40px;
    height: 40px;
    margin-bottom: -0.5rem;
  }
`

function IndexPage(props) { 
  return (
  <div>
    <SEO title="Home" />
     <Layout>
      <HeroContainer>
        <HeroText data-sal="slide-right" data-sal-easing="ease" data-sal-duration="1500">I came here to find the true Bobby McGee<BallTitleImg src={Ball} alt="bouncing ball" /></HeroText>
        <HeroImageContainer>
          <Img fluid={props.data.imageOne.childImageSharp.fluid} alt="Author with her dalmatian" />
        </HeroImageContainer>
      </HeroContainer>
      <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
      <IntroTextContainer data-sal="slide-up" data-sal-easing="ease" data-sal-duration="800">
        <IntroText>A heartwarming true story about a young runaway seeking a new life and an identity all her own.<br/><br/>
          With the help of a spunky dalmatian named Bobby, Janis braves unpredictable and often dangerous roads from California to Florida.
        </IntroText>
      </IntroTextContainer>
      <DividerImgContainer>
        <Img fluid={props.data.imageTwo.childImageSharp.fluid} alt="Author with her dalmatian" />
      </DividerImgContainer>
      <BookTaglineContainer>
        <Tagline data-sal="slide-right" data-sal-easing="ease" data-sal-duration="1500">It sometimes takes 3,000 miles and the adventure of a lifetime to learn that we are much more than our past, and the best helping hands sometimes don't even have thumbs.</Tagline>
        <TaglineImgContainer>
          <Img fluid={props.data.imageThree.childImageSharp.fluid} alt="Author with her dalmatian" />
        </TaglineImgContainer>
        <TaglineDecoration data-sal="slide-left" data-sal-easing="ease" data-sal-duration="1000">
          <Img fluid={props.data.imageFour.childImageSharp.fluid} alt="Paw print" />
        </TaglineDecoration>
      </BookTaglineContainer>
      <MapContainer>
        <MapTextContainer data-sal="slide-up" data-sal-easing="ease" data-sal-duration="1500">
          Janis &amp; Bobby's Journey<MapBallImg src={Ball} alt="bouncing ball" />
        </MapTextContainer>
        <Map />
      </MapContainer>
      <CallToActionContainer>
        <BookImgContainer>
          <Img fluid={props.data.imageFive.childImageSharp.fluid} alt="Me and Bobby McGee Book Cover" />
        </BookImgContainer>
        <ActionTextWrapper>
          <ActionText>Be part of Janis and Bobby's adventure<BallActionImg src={Ball} alt="bouncing ball" /></ActionText>
          <CheckoutButton />
        </ActionTextWrapper>
      </CallToActionContainer>
     </Layout>
  </div>
  )
}

export default IndexPage

export const query = graphql`
query {
  imageOne: file(relativePath: { eq: "hero.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
  imageTwo: file(relativePath: { eq: "hug-dog-2.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
  imageThree: file(relativePath: { eq: "hugging-dog.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
  imageFour: file(relativePath: { eq: "paw-print.png" }) {
    childImageSharp {
      fluid(maxWidth: 1300, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
  imageFive: file(relativePath: { eq: "book-mockup.png" }) {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
}
`